<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>

          <!-- HEADER -->
          <h1 class="mb-4">{{$t("Set weight")}}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

          <div style="max-width:1100px">
            <!-- SUMMARY -->
            <div v-if="scReg != null && scReg.Registration != null">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.ArticleNo}} - {{scReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.VehicleNo}} - {{scReg.Registration.VehicleLicensePlateNo}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.CustomerNo}} - {{scReg.Registration.CustomerName}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("WeightNet")}}:</v-flex>
                    <v-flex d-flex xs8>{{getWeightStr(scReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Tare")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.TareWeight}} kg</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.PlantNo}} - {{scReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <v-layout  row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.ScanXRegNo}}</v-flex>
                    <div class="red--text">{{ scReg.Registration.ScanXRegNo === 0 ? $t('Awaiting Weight ID from ScanX.NET') : ''}}</div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>

            <div>
              <v-layout xs12 sm12 align-center >
                <v-flex>
                  <v-text-field  v-if="scReg != null && scReg.Registration != null && !isHide('Comment')" class="ml-2 mr-2" hide-details="true" v-model="scReg.Registration.Comment1" :maxlength="100" :label="$t('Comment')"></v-text-field>
                  <!-- WEIGHT DISPLAY -->
                  <v-layout row wrap class="textsize-svs" style="padding: 10px 8px 4px 8px" >
                    <v-flex d-flex xs12 sm12 class="textsize-large thin-border" style="min-height:50px; align-items:center; justify-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                      <div class="text-center">
                        {{form.weightNetString}} kg
                      </div>
                    </v-flex>
                  </v-layout>

                  <!-- SCAN CODE SCALE BUTTON -->
                  <v-flex v-if="enableScaleWeightIntegration" d-flex xs12 sm12 class="textsize-svs">
                    <v-btn :disabled="!isAlive" block color="info" class="numPadBtn text-lowercase"
                        @click="get_Scan_Code_Weight()"
                        @contextmenu="ScanCodeIdHandler($event)">
                      <v-icon x-large>arrow_drop_up</v-icon>
                      <div><div v-html="ScanCodeIcon"></div><div class="textsize-vt25 mr-n1 mt-n1 text-uppercase">{{ activeScale ? activeScale : '?' }}</div></div>
                      <div>{{ displayWeight }}</div>
                      <v-icon x-large>arrow_drop_up</v-icon>
                    </v-btn>
                  </v-flex>

                  <!-- NUM PAD -->
                  <v-flex d-flex sm2></v-flex>
                  <v-layout row class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(7)">7</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(8)">8</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(9)">9</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="warning" class="txtPadBtn" @click="weightRemove()"><v-icon class="d-md-none">backspace</v-icon><div class="d-none d-md-block">C</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(4)">4</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(5)">5</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(6)">6</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="error" class="txtPadBtn" @click="preventLeave = false; changeSetWeightStatus(''); $router.push({ name: redirectTo })"><v-icon class="d-md-none">cancel</v-icon><div class="d-none d-md-block">{{$t("Cancel")}}</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(1)">1</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(2)">2</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(3)">3</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="success" class="txtPadBtn" @click="submit()" :loading="submitting"><v-icon class="d-md-none">done</v-icon><div class="d-none d-md-block">{{$t("Ok")}} {{buttonAppend}}</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm4><v-btn block color="primary" class="numPadBtn" @click="weightAppend(0)">0</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(decimalSeparator)">{{decimalSeparator}}</v-btn></v-flex>
                    <v-flex d-flex xs5 sm3><v-btn block color="success" class="txtPadBtn" @click="form.weightNetString - scReg.TareWeight <= 0 ? confirmZeroKgDialog=true : finishRegistration()" :loading="submitting">{{$t("Finish")}} {{buttonAppend}}</v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>

        <!-- SELECT ACTIVE SCALE DIALOG -->
        <v-dialog v-model="ScanCodeIdDialog" max-width="380" persistent>
          <v-card >
            <v-card-title @click="simulateWeightFromScanCode" class="headline">{{$t("Scale weight input")}}</v-card-title>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions>
              <v-card-text>
              <v-select class="mt-n2 mb-6" hide-details="true" :clearable="true" :items="ScaleList" v-model="selectedScale" :label="$t('Select active scale')"></v-select>
              <v-btn class="ml-9" x-large color="success" @click="ScanCodeIdDialog = false; saveScale(selectedScale)">{{$t("Ok")}}</v-btn>
              <v-btn class="ml-4" x-large color="primary" @click="ScanCodeIdDialog = false">{{$t("Cancel")}}</v-btn>
            </v-card-text>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="confirmZeroKgDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("NoWeightAdded")}}</v-card-title>
            <v-card-text>{{$t("NoWeightDescription")}}</v-card-text>
            <v-card-text>{{$t("Tare")}} (kg): {{TareWeight}}</v-card-text>
            <v-card-text>{{$t("WeightNet")}}: {{form.weightNetString - scReg.TareWeight}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="confirmZeroKgDialog = false">{{$t("Ok")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as ScanCode from '@/modules/scan-code/scan-code'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import * as DateUtil from '@/core/date'
import * as Log from '@/core/logger'
import SVGIcons from '@/assets/svg/SVGIcons'
import * as Archive from '@/core/archive'

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'scan-code-registration',
    loading: true,
    submitting: false,
    confirmZeroKgDialog: false,
    valid: true,
    redirectTo: 'scan-code-registrations',
    decimalSeparator: ',',
    maxDecimalCount: 2,
    TareWeight: 0,
    userName: Security.user.name.split('.')[1], // set username ex. SVS.Ole => Ole
    form: {
      weightNet: 0,
      weightNetString: ''
    },
    scReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      finishedDate: null,
      finishedBy: null,
      comment: null,
      reg: null,
      TareWeight: 0
    },
    ScanCodeIcon: SVGIcons.ScanCodeScaleIcon,
    enableScaleWeightIntegration: false,
    isAlive: true,
    // ScaleIpPort: '0.0.0.0:1234',
    checkIsAliveTimer: null,
    checkkingIsAlive: false,
    activeScale: null,
    selectedScale: null,
    displayWeight: '',
    ScanCodeIdDialog: false,
    ScaleList: [],
    // allowSimulation: false, // if ScaleList from server is empty allow simulation weight for 'Scale #1' and 'Scale #2' by left click on the weight
    simulationWeight: 0,
    firstErrorStatus: '',

    errorTexts: [
      { text: 'S', value: 'The scale is stable, with a valid weight.' },
      { text: 'U', value: 'The scale is in an unstable condition. Please wait and try again.' },
      { text: 'Timeout', value: 'Timeout. Weight data too old (>10 secs). Please wait and try again.' },
      // TODO: Perhaps delete the rest of these error texts
      { text: 'Z', value: 'The scale must be set to zero.' },
      { text: 'WU', value: 'Warm-up strokes must be performed.' },
      { text: 'W', value: 'Weighing allowed.' },
      { text: 'WB', value: 'As for Weighing allowed, but with re-weighing active.' },
      { text: 'F', value: 'The contents of the bucket have been weighed and added. The loading bucket must be emptied.' },
      { text: 'ENA', value: 'Error: top of zero range exceeded.' },
      { text: 'ENI', value: 'Error: bottom of zero range exceeded.' },
      { text: 'ES', value: 'Error: unstable weighing process.' },
      { text: 'EWA', value: 'Error: maximum load exceeded.' },
      { text: 'EWI', value: 'Error: minimum load required.' },
      { text: 'ET', value: 'Error: vehicle is tilted.' },
      { text: 'ELSF', value: 'Error: Alibi memory is full.' },
      { text: 'ZERO', value: 'The scale cannot be set to zero. Check Scale is ON. If ON, press "Stand-By" and touch screen, to turn ON again.' },
      { text: 'NoWeight', value: 'No Weight data ready. Please wait. Check Scale is ON. If ON, press "Stand-By" and touch screen, to turn ON again.' },
      { text: 'ResetWeight', value: 'The scale must be reset to zero. Please wait and try again.' }
    ],
    hiddenFields: []

  }),
  computed: {},
  methods: {
    getWeightStr (scReg) {
      // Weighing is via ScanCode
      return (scReg.Registration.WeightFirst - this.scReg.TareWeight) + ' kg'
    },
    async finishRegistration () {
      // Grab an update of the reg to get ScanXRegNo etc.
      const res2 = await ScanCode.loadRegistration(this.scReg.id)
      if (!res2.failed) {
        const comment = this.scReg.Registration.Comment1
        this.scReg.Registration = res2.data.Registration
        this.scReg.Registration.Comment1 = comment
      }

      if (this.scReg.Registration.ScanXRegNo === 0) {
        this.$root.$message.showError(this.$t('Awaiting Weight ID from ScanX.NET'))
        return
      }

      // Tare calulation for ScanCode ONLY on Finish reg (Also im FinishRegistration.vue)
      this.scReg.Registration.DateFirst = new Date()
      this.scReg.Registration.WeightSecond = this.scReg.TareWeight
      this.scReg.Registration.DateSecond = new Date()
      this.scReg.Registration.WeightNet = this.scReg.Registration.WeightFirst - this.scReg.Registration.WeightSecond

      var convertedValue = this.checkWeightInput()
      if (convertedValue == null) return
      this.updateWeight(convertedValue)
      this.submitting = true
      this.confirmDialog = false
      this.preventLeave = false
      const res = await ScanCode.saveRegistration({
        Id: this.scReg.id,
        RegistrationId: this.scReg.registrationId,
        Facility: this.scReg.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: this.scReg.finishedBy,
        Comment: this.scReg.comment,
        Registration: this.scReg.Registration
      })
      this.submitting = false
      if (!res.failed) {
        this.preventLeave = false
        this.$root.$message.showSuccess(this.$t('Registration finished'))
        this.$router.push({ name: this.redirectTo })
      }
    },
    // Append the char to the weight
    weightAppend (char) {
      // Start checking the rules.
      if (this.form.weightNetString === '0') {
        if (char >= 1 && char <= 9) {
          // If already entered 0, and entering a value between 1 and 9, then remove the 0.
          this.form.weightNetString = ''
        } else if (char === 0) {
          // If already entered 0, and entering 0 again, then ignore it.
          return
        }
      } else if (this.form.weightNetString === '') {
        if (char === this.form.decimalSeparator) {
          // If the string is empty, and entering comma, then add a 0 first.
          this.form.weightNetString = '0'
        }
      } else if (this.form.weightNetString.indexOf(this.form.decimalSeparator) > -1) {
        if (char === this.form.decimalSeparator) {
          // If the string already contains a comma, and entering comma again, then ignore it.
          return
        }

        // Count the number of decimals already entered.
        var decimalCount = this.form.weightNetString.split(this.form.decimalSeparator)[1].length || 0
        if (decimalCount >= this.form.maxDecimalCount) {
          // If more decimals than allowed are already entered, then ignore them.
          // But let's tell the user
          this.$root.$message.showInfo(this.$t('No more decimals are allowed.'))
          return
        }
      }

      // Now append the new char
      this.form.weightNetString += ('' + char)
    },
    weightRemove () {
      // Remove the last char
      this.form.weightNetString = this.form.weightNetString.substr(0, this.form.weightNetString.length - 1)
    },
    checkWeightInput () {
      // Convert the weightNetString to weightNet
      var convertedValue = parseFloat(this.form.weightNetString)
      if (convertedValue === undefined || convertedValue === null || isNaN(convertedValue)) {
        this.$root.$message.showError(this.$t('Invalid format of entered weight'))
        return null
      }

      // The type of WeightNet in the database is a Decimal(18,6)
      // The maximum number of a Decimal(18,6) is (18-6)=12x '9' before the separator and 6x '9' after the separator. So 999999999999,999999
      // Let's just check for 6x '9' without the decimals.
      if (convertedValue > 999999) {
        this.$root.$message.showError(this.$t('WeightTooBig'))
        return null
      }
      return convertedValue
    },
    updateWeight (weight) {
      this.form.weightNet = weight
      this.scReg.Registration.DateFirst = new Date()
      this.scReg.Registration.WeightFirst = this.form.weightNet
      this.scReg.Registration.WeightNet = this.scReg.Registration.WeightFirst - this.scReg.TareWeight
    },
    async get_Scan_Code_Weight () {
      // First time Select active Scale
      if (!this.activeScale) {
        this.ScanCodeIdDialog = true
        return
      }
      this.isAlive = false // disable ScanCode button

      // Get Scale sum weight
      const res = await ScanCode.getWeight({ ScaleId: this.activeScale, ResetWeight: 'False' })
      if (!res.failed) {
        if (res.data.Status === 'S') {
          if (res.data.TotalWeight > 0) {
            this.form.weightNetString = res.data.TotalWeight.toString()
            this.updateWeight(res.data.TotalWeight)
            this.$root.$message.showInfo(this.$t('Weight') + ' ' + this.form.weightNetString + ' kg ' + this.$t('transferred'))
            this.firstErrorStatus = ''
            // await ScanCode.getWeight({ ScaleId: this.activeScale, ResetWeight: 'True' }) // only send reset, ignore weight
          } else {
            this.$root.$message.showError(this.$t('NoWeightAdded') + ' (0 kg)')
          }
        } else {
          if (res.data.Status === 'U') {
            this.form.weightNetString = res.data.TotalWeight.toString()
            const error = this.errorTexts.find(e => e.text === res.data.Status).value
            this.$root.$message.showError(error)
          } else {
            if (!this.firstErrorStatus) this.firstErrorStatus = res.data.Status
            const errorTxt = this.errorTexts.find(e => e.text === this.firstErrorStatus).value
            const error = this.$t('Weight communication problem. Check Scale is Ready.') + ' [Code: ' + this.firstErrorStatus + '] ' + errorTxt
            this.$root.$message.showError(error)
            Log.log('Error in get_Scan_Code_Weight:', error, res.data)
          }
        }
        this.isAlive = true // enable ScanCode button
        this.displayWeight = ''
      }
    },
    ScanCodeIdHandler (event) {
      this.selectedScale = this.activeScale
      this.ScanCodeIdDialog = !this.ScanCodeIdDialog
      event.preventDefault()
    },
    saveScale () {
      if (this.selectedScale) {
        this.activeScale = this.selectedScale
        LocalStorage.save('activeScale', this.activeScale)
      } else {
        LocalStorage.remove('activeScale')
        this.ScaleList = []
      }
    },
    async simulateWeightFromScanCode () {
      if (!this.activeScale) {
        console.log('ScaleList = "Scale #1"')
        // Simulation Scale ids, if none found in service (no Scale is sending Weight results yet)
        // simulateWeightFromScanCode: click on headline "Scan Code weight input" in
        // Select active Scan Code via Scan Code button long press (contextmenu)
        this.ScaleList = ['Scale #1']
        this.activeScale = 'Scale #1'
        this.selectedScale = 'Scale #1'
      } else {
        const res = await ScanCode.uploadWeight({
          ScaleId: this.activeScale,
          ScaleWeightData: {
            AddedDate: DateUtil.getRealDate(Date.now()),
            NumberOfWeighings: 1,
            Status: (this.simulationWeight / 100) % 3 === 0 ? 'U' : 'S',
            TotalWeight: this.simulationWeight,
            Unit: 'kg',
            VoucherNumber: 1
          }
        })
        this.simulationWeight += 100
        if (res.failed) { console.log('Simulate uploadWeight() error') }
      }
    },

    async submit () {
      // Grab an update of the reg to get ScanXRegNo etc.
      const res2 = await ScanCode.loadRegistration(this.scReg.id)
      if (!res2.failed) {
        const comment = this.scReg.Registration.Comment1
        this.scReg.Registration = res2.data.Registration
        this.scReg.Registration.Comment1 = comment
      }

      var convertedValue = this.checkWeightInput()
      if (convertedValue == null) return
      this.updateWeight(convertedValue)
      this.submitting = true
      const res = await ScanCode.saveRegistration({
        Id: this.scReg.id,
        RegistrationId: this.scReg.registrationId,
        Facility: this.scReg.facilityNo,
        FinishedDate: this.scReg.finishedDate,
        FinishedBy: this.scReg.finishedBy,
        Comment: '', // clear InUseBy
        Registration: this.scReg.Registration
      })
      this.submitting = false
      if (!res.failed) {
        this.preventLeave = false
        this.$root.$message.showSuccess(this.form.weightNet + ' kg ' + this.$t('Saved').toLowerCase())
        this.$router.push({ name: this.redirectTo })
      }
    },
    async changeSetWeightStatus (val) {
      this.scReg.Comment = val // Set button "Set weight (userName)" or clear button (val = '') // InUseBy
      await ScanCode.saveRegistration({
        Id: this.scReg.id,
        RegistrationId: this.scReg.registrationId,
        Facility: this.scReg.facilityNo,
        Comment: this.scReg.Comment,
        Registration: this.scReg.Registration
      }, true)
      // When SaveOnlyComment is true we dont save the registration - and there should be no need to loaded and that is why below code is commented out
      // if (!res.failed) {
      //   if (val) {
      //     // Reload Pre registration, so Save works again
      //     this.scReg.id = this.$route.params.id
      //     const res2 = await ScanCode.loadRegistration(this.scReg.id)
      //     if (!res2.failed) {
      //       if (res2.data.Registration.WeightFirst > 0) {
      //         this.form.weightNet = res2.data.Registration.WeightFirst
      //         this.form.weightNetString = '' + this.form.weightNet
      //       }
      //       this.scReg.registrationId = res2.data.RegistrationId
      //       this.scReg.facilityNo = res2.data.Facility
      //       this.scReg.finishedDate = res2.data.FinishedDate
      //       this.scReg.finishedBy = res2.data.FinishedBy
      //       this.scReg.CreatedBy = res2.data.CreatedBy
      //       this.scReg.comment = res2.data.Comment
      //       this.scReg.Registration = res2.data.Registration
      //     }
      //   }
      // }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    }
  },
  beforeDestroy () {
    // Stop live poll Scale getWeight
    if (this.getLiveWeightTimer) {
      this.checkkingIsAlive = false
      clearInterval(this.getLiveWeightTimer)
    }
    if (this.getRegTimer) clearInterval(this.getRegTimer)
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    /* const res = await ScanCode.getCurrentWeightIds(this.scReg.facilityNo)
    if (!res.failed && res.data.length) {
      this.ScaleList = res.data
    } */

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      this.enableScaleWeightIntegration = true // TODO: (Security.user.corporationDetails.find(d => d.Name === 'ScanCode_Enable_Scale_Weight_Integration')?.Data1 === 'true')
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanCode_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }

    // Load current (stored) Scale id
    const Scale = LocalStorage.load('activeScale')
    if (Scale) { this.activeScale = Scale } else { LocalStorage.remove('activeScale') }

    // Start Timer with getWeight check to Scale box (and communication to Scale)
    this.getLiveWeightTimer = setInterval(async () => {
      // Only check IsAlive, if last check has ended
      if (this.enableScaleWeightIntegration && this.activeScale) {
        this.checkkingIsAlive = true
        const res = await ScanCode.getWeight({ ScaleId: this.activeScale, ResetWeight: 'False' })
        if (res.failed) {
          this.isAlive = false
          this.displayWeight = '�'
          this.firstErrorStatus = 'No connection'
          this.$root.$message.showError('GetWeight for "' + this.activeScale + '" errors')
        } else {
          if (res.data.Status === 'S') { // S = Stable
            if (!this.isAlive) this.isAlive = true // enable ScanCode button
            this.displayWeight = res.data.TotalWeight.toString() + ' kg'
            this.firstErrorStatus = ''
          } else {
            if (!this.firstErrorStatus) this.firstErrorStatus = res.data.Status
            this.displayWeight = res.data.TotalWeight.toString() + ' kg'
            this.isAlive = false // disable ScanCode button
          }
        }
        this.checkkingIsAlive = false
      }
    }, 2000)

    if (this.$route.params.id) {
      this.scReg.id = this.$route.params.id
      const res = await ScanCode.loadRegistration(this.scReg.id)
      if (!res.failed) {
        if (res.data.Registration.WeightFirst > 0) {
          this.form.weightNet = res.data.Registration.WeightFirst
          this.form.weightNetString = '' + this.form.weightNet
        }
        this.scReg.registrationId = res.data.RegistrationId
        this.scReg.facilityNo = res.data.Facility
        this.scReg.finishedDate = res.data.FinishedDate
        this.scReg.finishedBy = res.data.FinishedBy
        this.scReg.CreatedBy = res.data.CreatedBy
        this.scReg.comment = res.data.Comment
        this.scReg.Registration = res.data.Registration
        var res2 = await Archive.loadVehicle({ facilityNo: this.scReg.Registration.Facility, vehicleNo: this.scReg.Registration.VehicleNo })
        if (!res2.failed) {
          this.scReg.TareWeight = Math.round(res2.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
          this.TareWeight = this.scReg.TareWeight
        }
      }
    } else {
      // ERROR
      // Calling this view incorrectly.
      this.$root.$message.showError(this.$t('Invalid registration id'))
    }

    var resW = await ScanCode.getCurrentWeightIds(this.scReg.facilityNo)
    if (!resW.failed && resW.data.length) {
      this.ScaleList = resW.data
    }

    this.$nextTick(() => {
      this.loading = false
    })

    this.changeSetWeightStatus(this.userName) // Set Weight Status to 'Set weight (userName)' // InUseBy
  }
}
</script>
